var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterLevelGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09912 10C3.09912 12 4.09912 12.5 5.09912 12.5C6.09912 12.5 7.09912 12 7.09912 10C7.09912 8.4 5.59912 6.5 5.09912 6C4.59912 6.5 3.09912 8.4 3.09912 10Z",
    fill: "#26A4FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.09912,
    cy: 3,
    r: 2.5,
    fill: "#26A4FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09912 5V16",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09912,
    y: 7,
    width: 3,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09912,
    y: 9,
    width: 2,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09912,
    y: 11,
    width: 3,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09912,
    y: 13,
    width: 2,
    height: 1,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLevelGauge);
export default __webpack_public_path__ + "static/media/water-level-gauge.786d57a97640ce8c845c369b7f7ccfb9.svg";
export { ForwardRef as ReactComponent };